import { type OfferPlanKey } from "@/lib/payments/offer-plan";

/** How many modules each course on sale has, keyed like the catalog cards (offerPlanKey). */
export type CatalogModuleCounts = Partial<Record<OfferPlanKey, number>>;

export const DEFAULT_CATALOG_MODULE_COUNTS: CatalogModuleCounts = {
  literacy: 4,
  agentic: 6,
  professionals: 6,
};

export async function getCatalogModuleCounts(): Promise<CatalogModuleCounts> {
  return DEFAULT_CATALOG_MODULE_COUNTS;
}
